import React from 'react';
import {Dialog, Icon, PriorityIcon} from '@priority-software/priority-style-react';
import styles from '.././styles.module.scss';
import {useEffect} from 'react';
import {AnnouncementItems} from '../consts/types';
import {sendAnalyticsMonitor} from '../../../utils/monitoring';
import {Footer} from './Footer';
import {DialogContent} from './DialogContent';
import {texts} from '../data/texts';
import {ModernTooltip} from '../../../components/Common/Tooltip/ModernTooltip';
import {isRTL} from '../../../Localization';
import {getAnnouncementsShowMoreLink} from './utils';
import classNames from 'classnames';

interface AnnouncementDialogPrpos {
    announcement: AnnouncementItems[];
    onClose: () => void;
    curPageIndex: number;
    setCurPageIndex: (index: number) => void;
    showMoreLinkHandler: (linkUrl: string) => void;
}
export const AnnouncementDialog = (props: AnnouncementDialogPrpos) => {
    const {announcement, onClose, curPageIndex, setCurPageIndex, showMoreLinkHandler} = props;
    const {content, title, additionalContent, monitoring, lottieContent, hideCloseBtn, linkText} =
        announcement[curPageIndex];
    const pagesCounter = announcement.length;
    const isLastPage = curPageIndex === pagesCounter - 1;
    const forwardBtnText = isLastPage ? texts.finalStep : texts.nextBtn;
    const backwardsBtnText = texts.backBtn;

    const isRtl = isRTL();
    const linkUrl = getAnnouncementsShowMoreLink(isRtl);

    useEffect(() => {
        const logoImg = new Image();
        logoImg.src = `${window['baseUrl']}/images/logo_black.svg`;
    }, []);

    const onForward = () => {
        setCurPageIndex(curPageIndex + 1);
    };

    const handleConfirmBtn = () => {
        if (monitoring?.forwardBtn) {
            sendAnalyticsMonitor(monitoring.forwardBtn);
        }
        isLastPage ? onClose() : onForward();
    };

    const handleBackBtn = () => {
        setCurPageIndex(curPageIndex - 1);
    };

    const handleClose = () => {
        if (monitoring?.closeBtn) {
            sendAnalyticsMonitor(monitoring.closeBtn);
        }
        onClose();
    };

    return (
        <Dialog
            size="small"
            width={640}
            isOpen={true}
            closeIcon={
                <ModernTooltip position="top" tooltip={texts.closeTooltip}>
                    <Icon
                        icon={PriorityIcon.closeSmall}
                        componentClasses={classNames({[styles.hide]: hideCloseBtn})}
                    />
                </ModernTooltip>
            }
            componentClasses={styles.dialog}
            onClose={handleClose}
            content={
                <DialogContent
                    content={content}
                    title={title}
                    additionalContent={additionalContent}
                    lottieContent={lottieContent}
                    linkText={linkText}
                    linkUrl={linkUrl}
                    showMoreLinkHandler={showMoreLinkHandler}
                />
            }
            footer={
                <Footer
                    announcement={announcement}
                    dotsCounter={pagesCounter}
                    curPageIndex={curPageIndex}
                    handleConfirmBtn={handleConfirmBtn}
                    handleBackBtn={handleBackBtn}
                    forwardBtnText={forwardBtnText}
                    backwardsBtnText={backwardsBtnText}
                />
            }
        />
    );
};
